import React from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";
import { useSurvey } from "../../hooks/useSurvey";

export function Header() {
  var { tSurvey: t } = useAppTranslation.Survey();
  var survey = useSurvey();

  return (
    <div className={styles.root}>
      <img src={survey.data?.accountLogoUrl} alt="logo" />
      {survey.data?.obUrl && (
        <a href={survey.data?.obUrl} target="_blank" rel="noreferrer noopener">
          {t("book_appointment")}
        </a>
      )}
    </div>
  );
}
